import { useQuery } from '@tanstack/react-query';
import {
  fetchCenterServices,
  fetchServiceSchedules,
  type WorkhourSchedule,
} from '@/modules/profile/utils/workhourSchedules';

/**
 * ساعت کاریِ پزشک به تفکیک مرکز، از همان سرویس عمومی drprofile که پروفایل و
 * «ساعات نوبت‌دهی» می‌خوانند (centers/{id}/services → doctor-services/{id}/schedules).
 * بدون توکن و فقط خواندنی؛ ساعت‌های همه‌ی خدمت‌های یک مرکز با هم جمع می‌شوند.
 */
const getCenterSchedules = async (slug: string, centerId: string): Promise<WorkhourSchedule[]> => {
  const services = await fetchCenterServices(slug, centerId).catch(() => []);
  const lists = await Promise.all(services.map(service => fetchServiceSchedules(service.id)));
  return lists.flat();
};

export const useDoctorWorkhourSchedules = (slug: string | undefined, centerIds: string[]) =>
  useQuery(
    ['doctorHome', 'workhourSchedules', slug, centerIds.join(',')],
    async () => {
      const entries = await Promise.all(
        centerIds.map(async centerId => [centerId, await getCenterSchedules(slug!, centerId)] as const),
      );
      return Object.fromEntries(entries) as Record<string, WorkhourSchedule[]>;
    },
    {
      enabled: !!slug && centerIds.length > 0,
      staleTime: 10 * 60 * 1000,
      retry: 1,
    },
  );
